import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import { Guid } from "guid-typescript";
import { plainToClass } from "class-transformer";
import { ProductsModel } from "../../store/models/productsApps/productsList";
import { getTenantId } from "../helper";
import { ProductsaddModel } from "../models/productsApps/ProductaddDTO";
import { ProductsEditModel } from "../models/productsApps/ProductEditDTO";
import { ProductsViewModel } from "../models/productsApps/productViewDTO";
import { AppsUpdateModel } from "../models/productsApps/AppUpdateDTO";
let ProductsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    let ProductsModule = class ProductsModule extends VuexModule {
        constructor() {
            super(...arguments);
            //listing
            this.products = [];
            this.product = null;
            this.responseProducts = [];
            //add
            this.productsadd = [];
            this.productadd = null;
            this.productEdit = null;
            //view
            this.productView = null;
            // appsEdit
            this.appEdit = null;
            this.apiNode = "Product";
        }
        //Action
        //Products
        async GetAllUsers() {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.get(url);
            if (data) {
                this.AddProducts(plainToClass(ProductsModel, data.productGridView));
                return data;
            }
        }
        async AddNewProduct(Product) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, Product);
            if (data) {
                this.SetProduct(plainToClass(ProductsaddModel, data.productGridView));
                return data;
            }
        }
        async GetProductEditById(productId) {
            var url = `${getTenantId()}/${this.apiNode}/` + productId;
            let { data } = await service.get(url);
            if (data) {
                this.SetSelectedProduct(plainToClass(ProductsEditModel, data.productsEditDTO));
                return data;
            }
        }
        async UpdateProduct(productsEditDTO) {
            var url = `${getTenantId()}/${this.apiNode}/` + "updateProduct";
            let { data } = await service.put(url, productsEditDTO);
            if (data) {
                return data;
            }
        }
        async GetProductView(viewProductId) {
            var url = `${getTenantId()}/${this.apiNode}/` + viewProductId + "/View";
            let { data } = await service.get(url);
            if (data) {
                this.SelectedProductView(plainToClass(ProductsViewModel, data.productsViewDTO));
                return data;
            }
        }
        //Apps
        async GetAppsEditById(appsId) {
            var url = `${getTenantId()}/${this.apiNode}/Apps/` + appsId;
            let { data } = await service.get(url);
            if (data) {
                this.GetApps(plainToClass(AppsUpdateModel, data.appsEditDTO));
                return data;
            }
        }
        async UpdateApps(appsEditDTO) {
            var url = `${getTenantId()}/${this.apiNode}/Apps` + "/upsertApps";
            let { data } = await service.post(url, appsEditDTO);
            if (data) {
                return data;
            }
        }
        // Mutations
        // Products
        AddProducts(products) {
            this.products = products;
        }
        SetProduct(productadd) {
            this.productsadd.push(productadd);
        }
        SetSelectedProduct(ProductsEditDTO) {
            this.productEdit = ProductsEditDTO;
        }
        SelectedProductView(ProductsViewDTO) {
            this.productView = ProductsViewDTO;
        }
        //apps
        GetApps(appsEditDTO) {
            this.appEdit = appsEditDTO;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], ProductsModule.prototype, "GetAllUsers", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof ProductsaddModel !== "undefined" && ProductsaddModel) === "function" ? _b : Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], ProductsModule.prototype, "AddNewProduct", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof Guid !== "undefined" && Guid) === "function" ? _d : Object]),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], ProductsModule.prototype, "GetProductEditById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof ProductsEditModel !== "undefined" && ProductsEditModel) === "function" ? _f : Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], ProductsModule.prototype, "UpdateProduct", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], ProductsModule.prototype, "GetProductView", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_j = typeof Guid !== "undefined" && Guid) === "function" ? _j : Object]),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], ProductsModule.prototype, "GetAppsEditById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof AppsUpdateModel !== "undefined" && AppsUpdateModel) === "function" ? _l : Object]),
        __metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
    ], ProductsModule.prototype, "UpdateApps", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProductsModule.prototype, "AddProducts", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_o = typeof ProductsaddModel !== "undefined" && ProductsaddModel) === "function" ? _o : Object]),
        __metadata("design:returntype", void 0)
    ], ProductsModule.prototype, "SetProduct", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_p = typeof ProductsEditModel !== "undefined" && ProductsEditModel) === "function" ? _p : Object]),
        __metadata("design:returntype", void 0)
    ], ProductsModule.prototype, "SetSelectedProduct", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_q = typeof ProductsViewModel !== "undefined" && ProductsViewModel) === "function" ? _q : Object]),
        __metadata("design:returntype", void 0)
    ], ProductsModule.prototype, "SelectedProductView", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_r = typeof AppsUpdateModel !== "undefined" && AppsUpdateModel) === "function" ? _r : Object]),
        __metadata("design:returntype", void 0)
    ], ProductsModule.prototype, "GetApps", null);
    ProductsModule = __decorate([
        Module({ dynamic: true, store: store, name: "productsApps", namespaced: true })
    ], ProductsModule);
    return ProductsModule;
})();
export default getModule(ProductsModule);
